/* global mixpanel */

import person from './userData';

const TRACKER_DEFAULT_STATUS = true;

/* getting data from vueX store  */
// const extractValue = (x = []) => {
//    const [item] = x.filter(c => c.name.toLowerCase() === 'mixpanel');
//    return item && typeof item.value !== 'undefined' ? item.value : TRACKER_DEFAULT_STATUS;
// };

const isMixpanelActive = TRACKER_DEFAULT_STATUS;

/*
 * Helper functions
 */
const titleCase = str => str.replace(/(^|\s)\S/g, t => t.toUpperCase());

const mixpanelPropertiesMap = paramObj => {
   const data = Object.assign({}, paramObj);
   if (data.Name) {
      data.$name = data.Name;
      delete data.Name;
   }

   if (data.Phone) {
      data.$phone = data.Phone;
      delete data.Phone;
   }

   if (data.Email) {
      data.$email = data.Email;
      delete data.Email;
   }

   if (data.Country) {
      data.$country_code = data.Country;
      delete data.Country;
   }

   if (data.FcTechSelection) {
      data['FusionCharts - Framework'] = data.FcTechSelection;
      delete data.FcTechSelection;
   }

   if (data.FeTechSelection) {
      data['FusionExport - Framework'] = data.FeTechSelection;
      delete data.FeTechSelection;
   }

   if (data.FtTechSelection) {
      data['FusionTime - Framework'] = data.FtTechSelection;
      delete data.FtTechSelection;
   }

   return data;
};

const filterFields = paramObj => {
   const data = Object.assign({}, paramObj);
   const fieldsNotReq = [
      'slackMessageTitle',
      'slackurl',
      '_csrf',
      'purpose',
      'form',
      'product',
      'techstack',
      'currentProduct',
   ];

   Object.keys(paramObj).forEach(key => {
      if (Object.prototype.hasOwnProperty.call(paramObj, key) && fieldsNotReq.indexOf(key) > -1) {
         delete data[key];
      } else {
         data[titleCase(key)] = data[key];
         titleCase(key) !== key && delete data[key];
      }
   });
   return mixpanelPropertiesMap(data);
};

const track = (tag, data = {}) => {
   // eslint-disable-next-line
   // console.log('Mixpanel status', isMixpanelActive, tag);
   if (isMixpanelActive && typeof mixpanel !== 'undefined' && mixpanel.track) {
      // mixpanel.track(tag, {
      //    ...data,
      // });

      /**
       * storing mixpanel event name in a window object for
       * future reference and also to get last event name & data.
       */
      window.mixpanelLastTagPassed = {
         name: tag,
         data,
      };
   }
};

const identify = data => {
   if (typeof mixpanel !== 'undefined' && mixpanel.people) {
      mixpanel.identify();

      if (person.profileData && person.profileData.email) {
         mixpanel.people.set({
            ...filterFields(data),
         });
      }
   }
};

const tracker = (eventName, data = {}) => {
   if (eventName) {
      track(eventName, data);
   }
};

const getProductAndFramework = () => {
   const product = person.profileData.currentProduct;
   let framework = '';

   if (product === 'FusionCharts') {
      framework = person.profileData.fcTechSelection;
   } else if (product === 'FusionExport') {
      framework = person.profileData.feTechSelection;
   }

   return { Product: product, Framework: framework };
};

const getUserDetails = data => ({
   Name: data.name,
   Email: data.email,
   Company: data.company,
   Phone: data.phone,
   Industry: data.industry,
   ...(data.developer && { Developer: data.developer }),
});

/*
 * Returns version number
 */
const getDownlaodPageVersion = () => {
   const { href } = window.location;
   let version = 1;

   if (href.indexOf('version') > -1) {
      const paramsStr = href.split('?')[1];
      const paramsArr = paramsStr.split('&');

      paramsArr.forEach(p => {
         if (p.indexOf('version') > -1) {
            [version] = p.match(/\d+/);
         }
      });
   }
   return version;
};

/*
 *
 */
const getFramework = (data = {}) => {
   let framework = '';

   if (data.product === 'FusionCharts') {
      framework = data.framework || person.profileData.fcTechSelection;
   } else if (data.product === 'FusionExport') {
      framework = data.framework || person.profileData.feTechSelection;
   } else if (data.product === 'FusionTime') {
      framework = data.framework || person.profileData.ftTechSelection || 'js';
   }

   return framework;
};

/*
 * Module trackers
 */

const userProfile = {
   information: (data = {}) => {
      // Update data in local storage
      person.profileData = { ...person.profileData, ...data };

      // Sending user details to mixpanel
      identify(data);
   },

   formInitiated: (data = {}) => {
      track('Form Initiated', {
         ...filterFields(data),
      });
   },

   productBrowse: (data = {}) => {
      const products = (person.profileData && person.profileData.products) || [];
      const chartCategories = (person.profileData && person.profileData.chartCategories) || [];

      let fcTechSelection = (person.profileData && person.profileData.fcTechSelection) || '';
      let feTechSelection = (person.profileData && person.profileData.feTechSelection) || '';
      let ftTechSelection = (person.profileData && person.profileData.ftTechSelection) || '';

      // Updating current product
      userProfile.information({
         currentProduct: data.product,
      });

      if (products.indexOf(data.product) === -1 && data.product) {
         products.push(data.product);
         person.profileData = { products: [...products] };

         identify({
            Products: products,
         });
      }

      const details = {};

      if (chartCategories.indexOf(data.chartCategory) === -1 && data.chartCategory) {
         chartCategories.push(data.chartCategory);
         person.profileData = { chartCategories: [...chartCategories] };

         person.profileData.email && (details['Chart Categories'] = chartCategories);
      }

      if (data.technology && data.product === 'FusionCharts') {
         fcTechSelection = data.technology;
         person.profileData = { fcTechSelection };

         person.profileData.email && (details['FusionCharts - Technology'] = fcTechSelection);
      }

      if (data.technology && data.product === 'FusionExport') {
         feTechSelection = data.technology;
         person.profileData = { feTechSelection };

         person.profileData.email && (details['FusionExport - Technology'] = feTechSelection);
      }

      if (data.technology && data.product === 'FusionTime') {
         ftTechSelection = data.technology;
         person.profileData = { ftTechSelection };

         person.profileData.email && (details['FusionTime - Technology'] = ftTechSelection);
      }

      if (typeof mixpanel !== 'undefined' && mixpanel.people) {
         mixpanel.people.set(details);
      }
   },
};

const common = {
   clickedOn: title => {
      track(`Clicked On ${title}`);
   },

   // FusionCharts - Framework
   setFCFramework: framework => {
      // Check current product & accordingly set framework
      // checking product
      const { pathname } = window.location;
      let product = 'FusionCharts' || person.profileData.currentProduct;

      if (pathname.indexOf('fusionexport') > -1) {
         product = 'FusionExport';
      } else if (pathname.indexOf('fusiontime') > -1) {
         product = 'FusionTime';
      }

      let tag = 'Set FusionCharts Framework';
      let key = 'fcTechSelection';

      if (product === 'FusionExport') {
         tag = 'Set FusionExport Framework';
         key = 'feTechSelection';
      } else if (product === 'FusionTime') {
         tag = 'Set FusionTime Framework';
         key = 'ftTechSelection';
      }

      if (tag !== 'Set FusionExport Framework' && tag !== 'Set FusionCharts Framework') {
         track(tag, {
            Framework: framework,
         });
      }

      // Setting FusionCharts - Framework in user profile
      userProfile.information({
         currentProduct: product,
         [key]: framework,
      });
   },

   setTheme: theme => {
      // track('Changed Theme', {
      //    Theme: theme,
      // });
   },
};

const resources = {
   whitepaper: {
      /**
       * Event will be fired when someone visit the resources whitepaper page
       */
      visited: () => {
         track('Whitepaper Overview Page Visited');
      },
      // Whenever someone selects a Whitepaper, this should be triggered.
      // This should be treated as an Event rather than a page visit, so that we can track how many people opened a
      // specific Whitepaper.
      selected: param => {
         track('Whitepaper Selected', { WhitePaper: param });
      },
      // Whenever the Download button is clicked on the Whitepaper Page
      downloadRequest: params => {
         track('Whitepaper Download Requested', params);
      },
   },
};

const reseller = {
   visited: () => {
      track('Reseller Page Visited');
   },
   interested: value => {
      track('Interested in a Reseller', { Reseller: value });
   },
   contact: ob => {
      track('Reseller Contacted', ob);
   },
};

const contactus = {
   visited: () => {
      track('Contact Us Page Visited');
   },
   contacted: ob => {
      track('Contact Us Form Submitted', ob);
   },
   support: () => {
      track('Interested in Support Query');
   },
   techSupport: ob => {
      const trackObj = {
         ...ob,
         Phone: person.profileData && person.profileData.phone,
         Country: person.profileData && person.profileData.country,
      };
      track('Support Query Requested', trackObj);
   },
};

const home = {
   /**
    * Event will be fired when someone visit the home page
    */
   visited: () => {
      track('Home Page Visited');
   },
};

const download = {
   /**
    * Event will be fired when someone visit the dowload page
    */

   visited: (product, framework = '') => {
      let key;

      if (product === 'FusionCharts') {
         key = 'fcTechSelection';
      } else if (product === 'FusionExport') {
         key = 'feTechSelection';
      } else if (product === 'FusionTime') {
         key = 'ftTechSelection';
      }

      if (key) {
         // Setting FusionCharts - Framework in user profile
         userProfile.information({
            currentProduct: product,
            [key]: framework,
         });

         const trackObj = {
            Product: product,
            Version: getDownlaodPageVersion(),
            ...(framework && framework !== '' && { Framework: framework }),
         };

         track('Download Page Visited', trackObj);
      }
   },

   /**
    * Event will be fired when download page  is visited regardless of the subfolder
    */
   modeChanged: (data = {}) => {
      // Updating user identity in mixpanel
      userProfile.productBrowse({ ...data });

      const trackObj = {
         Product: data.product,
         Mode: data.mode,
         Version: getDownlaodPageVersion(),
         Framework: getFramework(data),
      };

      track('Download Mode Selected', trackObj);
   },

   /*
    * Product changed on download page
    */
   productSelection: (data = {}) => {
      const framework = getFramework(data);
      const trackObj = {
         Product: data.product,
         Version: getDownlaodPageVersion(),
         ...(framework && framework !== '' && { Framework: framework }),
      };

      // Updating user identity in mixpanel
      userProfile.productBrowse({ ...data, framework });
      track('Download Product Changed', trackObj);
   },

   /**
    * DEPRECATED
    * Event will be on any filling forms input
    * formInitiated: license => trackForm('Download Form Autofilled', getProductAndFramework()),
    */

   /**
    * Event will be fired if form submission is successfull
    */
   formSubmit: data => {
      identify(data);
   },

   /**
    * When dowload of fusioncharts is initiated at user side
    */
   downloadFC: (data = {}) => {
      track('Download Initiated', {
         ...getUserDetails(data),
         ...getProductAndFramework(),
         Version: getDownlaodPageVersion(),
      });
   },

   downloadFE: (data = {}) => {
      track('Download Initiated', {
         ...getUserDetails(data),
         ...getProductAndFramework(),
         Version: getDownlaodPageVersion(),
      });
   },

   // TODO: only copy first instance of snippets
   copyNPM: () => {
      track('Download Initiated via Package Manager', getProductAndFramework());
   },

   /**
    * when a user submits the request for demo form.
    */
   requestDemoFormSubmit(data = {}) {
      track('Requested a Personalized Demo', getUserDetails(data));
   },
};

const dataStories = {
   // DEPERECATED
   // formInitiated: () => trackForm('Data Story Source Code Form Autofilled'),
   // DEPERECATED
   // consultationForm: () => trackForm('Data Story Consultation Form Autofilled'),
   // New
   visited: () => {
      track('Data Story Overview Page Visited');
   },
   select: ds =>
      track('Data Story Selected', {
         Dashboard: ds,
      }),
   formSubmit: ob => {
      const trackObj = {
         ...ob,
         Company: person.profileData && person.profileData.company,
      };
      track('Data Story Consultation Requested', trackObj);
   },
};

const dashboard = {
   interestedInSourceCode: name => {
      track('Interested in Dashboard Source Code', {
         Name: name,
      });
   },
   interestedInConsultation: name => {
      track('Interested in Dashboard Consultation', {
         Name: name,
      });
   },
   visited: () => track('Dashboard Overview Page Visited'),
   select: db =>
      track('Dashboard Selected', {
         Dashboard: db,
      }),
   // formInitiated: () => trackForm('Dashboard Source Code Form Autofilled'),
   // consultationForm: () => trackForm('Dashboard Consultation Form Autofilled'),
};

const checkout = {
   pageVisit: () => {
      track('Pricing Page Visited');
   },

   interestedInPricing: source => {
      track('Interested In Pricing', {
         Source: source,
      });
   },

   planSelection: (license, src) => {
      track('Plan Selected', {
         License: license,
         Source: src,
      });
   },

   verificationInitiated: license => {
      track('Verification Initiated', {
         License: license,
      });
   },

   compareBtnClick: () => {
      track('Compare Plans Click');
   },

   changePlan: plan => {
      track('Pricing Plan Changed', {
         Plan: plan,
      });
   },

   // verificationFormAutofilled: license =>
   //    trackForm('Verification Form Autofilled', { License: license }),

   // customQuoteFormAutofilled: type => trackForm('Custom Quote Form Autofilled', { Type: type }),

   proceededToPayment: (data, license) => {
      identify(data);

      track('Proceeded to Payment', {
         ...getUserDetails(data),
         License: license,
      });
   },

   interestedInCustomQuote: type => {
      track('Interested in Custom Quote', {
         Type: type,
      });
   },

   customQuoteRequested: (data, type) => {
      identify(data);

      track('Custom Quote Requested', {
         ...getUserDetails(data),
         Type: type,
      });
   },

   interestedInSalesQuery: src => {
      track('Interested in Sales Query', {
         Source: src,
      });
   },

   enterpriseSelected: () => {
      track('Enterprise seleted from dropdown');
   },

   salesQueryRequested: src => {
      track('Sales Query Requested', src);
   },

   betaDownloadRequested: src => {
      track('FusionGrid Beta Download Requested', src);
   },
};

const chartGallery = {
   /**
    * Event will be fired when someone visit the chart gallery page
    */
   visited: () => {
      track('Chart Gallery Visited');
   },
};

const featureGallery = {
   /**
    * Event will be fired when someone visit the feature gallery page
    */
   visited: () => {
      track('Feature Gallery Visited');
   },
};

const Integrations = {
   visited: () => {
      track('Integrations Visited');
   },
};

const chartGuides = {
   visited: () => {
      track('Chart Guides Visited');
   },
};

const anyProductPage = {
   /**
    * when a user visits any of the  product page.
    */
   visited: () => {
      track('FusionCharts | FusionTime | FusionExport Overview Visited');
   },
};

const fusionTime = {
   /**
    * when a user FusionTime Samples Visited.
    */
   visited: () => {
      track('FusionTime Samples Visited');
   },
};

const extensions = {
   visited: () => {
      track('Extensions Visited');
   },
};

const banner = {
   btnClicked: src => {
      track('Promotional Banner Clicked', {
         Source: src,
      });
   },
   hovered: () => {
      track('Hovered On Promotional Banner');
   },
};

export default store =>
   // isMixpanelActive = extractValue(store.state.adminBasicConfig);
   ({
      tracker,
      common,
      home,
      download,
      dashboard,
      checkout,
      userProfile,
      resources,
      reseller,
      contactus,
      dataStories,
      chartGallery,
      featureGallery,
      Integrations,
      chartGuides,
      anyProductPage,
      fusionTime,
      extensions,
      banner,
   });
